<script setup>

import ChangesCustomer from "../../../components/ui-components/settings/ChangesCustomer.vue";
import FeatureBlocker from "../../../components/ui-components/FeatureBlocker.vue";

const model = defineModel()
</script>

<template>
    <div>
        <div class="border rounded-xl max-w-[500px] bg-white dark:border-neutral-700 dark:bg-neutral-900">
            <FeatureBlocker name="roori_customer_can_change" version="Pro">
                <div class="p-6">
                    <changes-customer v-model="model.settings"></changes-customer>
                </div>
            </FeatureBlocker>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
